/**
 * Service worker registration.
 *
 * Registered only in production: in dev the SW would serve a stale shell and
 * make every change look like it didn't apply.
 */
export function registerServiceWorker() {
  if (!import.meta.env.PROD) return
  if (!('serviceWorker' in navigator)) return

  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((err) => {
      console.warn('Service worker registration failed', err)
    })
  })
}

/** True when running from the home screen rather than a browser tab. */
export function isInstalled(): boolean {
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    // iOS Safari predates display-mode and uses this instead
    (window.navigator as unknown as { standalone?: boolean }).standalone === true
  )
}

/** iOS has no install prompt event — it needs the Share-sheet instructions. */
export function isIos(): boolean {
  return /iphone|ipad|ipod/i.test(navigator.userAgent)
}
